import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
const forWho = ['Eres padre o madre hispano/a en EE.UU. que se sacrificó por el sueño americano', 'Quieres que tus hijos sean líderes, no víctimas de la automatización', 'Entiendes que el sistema escolar actual no es suficiente para el 2030', 'Estás dispuesto/a a invertir en la ventaja competitiva de tu familia', 'Quieres dejar un legado — de inmigrantes trabajadores a líderes del futuro'];
const notForWho = ['Crees que el sistema escolar lo tiene todo cubierto', 'Prefieres esperar a ver qué pasa con la IA', 'No estás dispuesto/a a dedicar 20 minutos semanales a guiar a tu hijo'];
export function ForWhoSection() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'linear-gradient(180deg, #050A14 0%, #080F20 100%)'
  }} data-id="element-57">
      <div className="max-w-4xl mx-auto" data-id="element-58">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-4xl md:text-5xl font-black text-center mb-14 leading-tight" style={{
        color: '#F1F5F9'
      }} data-id="element-59">
          ¿Para Quién Es{' '}
          <span style={{
          background: 'linear-gradient(90deg, #0EA5E9, #818CF8)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }} data-id="element-60">
            Este Manual?
          </span>
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-7" data-id="element-61">
          {/* For */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="p-8 rounded-2xl" style={{
          backgroundColor: '#0C1628',
          border: '1px solid rgba(14,165,233,0.18)'
        }} data-id="element-62">
            <h3 className="text-lg font-black mb-6 flex items-center gap-2" style={{
            color: '#F1F5F9'
          }} data-id="element-63">
              <CheckCircle size={20} style={{
              color: '#10B981'
            }} data-id="element-64" />
              Este Manual Es Para Ti Si...
            </h3>
            <div className="space-y-4" data-id="element-65">
              {forWho.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -15
            }} animate={inView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.5,
              delay: 0.2 + i * 0.08
            }} className="flex items-start gap-3" data-id="element-66">
                  <CheckCircle size={16} className="mt-0.5 flex-shrink-0" style={{
                color: '#10B981'
              }} data-id="element-67" />
                  <p className="text-sm leading-relaxed" style={{
                color: '#CBD5E1'
              }} data-id="element-68">
                    {item}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>

          {/* Not for */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="p-8 rounded-2xl flex flex-col" style={{
          backgroundColor: '#0C1628',
          border: '1px solid rgba(244,63,94,0.18)'
        }} data-id="element-69">
            <h3 className="text-lg font-black mb-6 flex items-center gap-2" style={{
            color: '#F1F5F9'
          }} data-id="element-70">
              <XCircle size={20} style={{
              color: '#F43F5E'
            }} data-id="element-71" />
              Este Manual NO Es Para Ti Si...
            </h3>
            <div className="space-y-4 mb-6" data-id="element-72">
              {notForWho.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 15
            }} animate={inView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.5,
              delay: 0.3 + i * 0.08
            }} className="flex items-start gap-3" data-id="element-73">
                  <XCircle size={16} className="mt-0.5 flex-shrink-0" style={{
                color: '#F43F5E'
              }} data-id="element-74" />
                  <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-75">
                    {item}
                  </p>
                </motion.div>)}
            </div>

            <div className="mt-auto p-4 rounded-xl text-sm leading-relaxed" style={{
            backgroundColor: 'rgba(245,159,11,0.07)',
            border: '1px solid rgba(245,159,11,0.2)',
            color: '#F59E0B'
          }} data-id="element-76">
              <strong data-id="element-77">
                La pregunta no es si la IA cambiará el mundo de tu hijo.
              </strong>{' '}
              La pregunta es: ¿Quién le enseñará a liderarlo?
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}